import React, { useState, useImperativeHandle, forwardRef, useEffect, useRef } from 'react'
import { Modal, Button, Tabs, Tab } from 'react-bootstrap';
import SaveButton from 'components/misc/Button';
import Loader from 'components/misc/Loader';
import Home from './Home';
import StorageMovements from './StorageMovements';
import Refs from 'Refs';
import NewDocument from '../partials/NewDocument';
import NewStoreMove from '../partials/NewStoreMove';

function View(props, ref) {

    const tabs = [
        {
            id: 'home',
            name: 'Преглед',
            component: Home
        },
        {
            id: 'storage',
            name: 'Складови движения',
            component: StorageMovements
        }
    ];

    const [state, setState] = useState({
        show: false,
        params: null,
        id: null,
        tabId: tabs[0].id,
        onClose: null,
    });

    const newDocumentModalRef = useRef(null);
    const newStoreMoveModalRef = useRef(null);

    useImperativeHandle(ref, () => ({
        open: (id) => {
            handleShow(id);
        },
        close: () => {
            handleClose();
        },
        onClose: fn => {
            setState(prev => ({
                ...prev,
                onClose: fn
            }));
        }
    }));

    const show = (onEntering = null) => {
        setState(prev => ({
            ...prev,
            show: true,
            onEntering: onEntering,
        }));
    }

    const hide = (onExiting = null) => {
        setState(prev => ({
            ...prev,
            show: false,
            onExiting: onExiting
        }));
    }

    const handleShow = (id) => {
        setState(prev => ({
            ...prev,
            id: id,
        }));

        show();
    }

    const handleClose = () => {
        setState(prev => ({
            ...prev,
            show: false,
            tabId: tabs[0].id
        }));

        if (typeof state.onClose === 'function') {
            hide(state.onClose);
        } else {
            hide();
        }

        setState(prev => ({
            ...prev,
            onClose: null,
        }));
    }

    const setKey = id => {
        setState(prev => ({
            ...prev,
            tabId: id,
        }));
    }

    const showArticle = id => {
        if (!id) {
            return;
        }

        let modal = Refs.getInstance().getRef('article');

        if (!modal) {
            return;
        }

        hide(() => {
            modal.open(id);
        });

        modal.onClose(() => {
            show();
        });
    }

    const addDocument = () => {
        let modal = newDocumentModalRef.current;

        if (!modal) {
            return;
        }

        hide(() => {
            modal.open(state.id);
        });

        modal.onSuccess(() => {
            // 
        });

        modal.onClose(() => {
            show();
        });
    }

    const addStoreMove = () => {
        let modal = newStoreMoveModalRef.current;

        if (!modal) {
            return;
        }

        hide(() => {
            modal.open(state.id);
        });

        modal.onSuccess(() => {
            // 
        });

        modal.onClose(() => {
            show();
        });
    }

    return (
        <>
            <NewDocument
                ref={newDocumentModalRef}
            />

            <NewStoreMove
                ref={newStoreMoveModalRef}
            />

            <Modal size="xl" centered show={state.show} onHide={handleClose} onEntering={state.onEntering} onExiting={state.onExiting}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        Преглед на прехвърляне
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Tabs
                        activeKey={state.tabId}
                        onSelect={(k) => setKey(k)}
                        className="mb-3"
                        mountOnEnter
                    >
                        {tabs.map(tab =>
                            <Tab key={tab.id} eventKey={tab.id} title={tab.name}>
                                {React.createElement(tab.component, {
                                    id: state.id,
                                    show: show,
                                    hide: hide,
                                    showArticle: showArticle,
                                    addDocument: addDocument,
                                    addStoreMove: addStoreMove,
                                })}
                            </Tab>
                        )}
                    </Tabs>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Затвори
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default forwardRef(View);